
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPhoneIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.38 4.5h7.24c1.09 0 1.636 0 2.058.21.37.183.679.493.862.862.21.422.21.968.21 2.059v8.738c0 1.091 0 1.637-.21 2.059-.183.37-.493.679-.862.862-.422.21-.968.21-2.059.21H8.381c-1.091 0-1.637 0-2.059-.21a1.93 1.93 0 0 1-.862-.862c-.21-.422-.21-.968-.21-2.059V7.631c0-1.091 0-1.637.21-2.059.183-.37.493-.679.862-.862.422-.21.968-.21 2.059-.21ZM10.5 17.25h3",
  stroke: "var(--theme-primary, #9631ff)",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M8.38086 4.5H15.6191C16.7101 4.5 17.2556 4.5 17.6777 4.70996C18.0472 4.893 18.357 5.20277 18.54 5.57227C18.75 5.99437 18.75 6.5399 18.75 7.63086V16.3691C18.75 17.4601 18.75 18.0056 18.54 18.4277C18.357 18.7972 18.0472 19.107 17.6777 19.29C17.2556 19.5 16.7101 19.5 15.6191 19.5H8.38086C7.2899 19.5 6.74437 19.5 6.32227 19.29C5.95277 19.107 5.643 18.7972 5.45996 18.4277C5.25 18.0056 5.25 17.4601 5.25 16.3691V7.63086C5.25 6.5399 5.25 5.99437 5.45996 5.57227C5.643 5.20277 5.95277 4.893 6.32227 4.70996C6.74437 4.5 7.2899 4.5 8.38086 4.5Z\" stroke=\"var(--theme-primary, #9631ff)\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M10.5 17.25H13.5\" stroke=\"var(--theme-primary, #9631ff)\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/phone-icon.cda831b8d161ac6c07e6fe322cbbff40.svg"),
        {
          React: SvgPhoneIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      